import { useLayoutEffect } from 'react'
import { useLocation } from '@reach/router'
import { navigate } from 'gatsby'
import useLink from './useLink'

interface useCreateStepsJudgementReturn {
  isInCreateSteps: boolean
}

const useCreateStepsJudgement = (): useCreateStepsJudgementReturn => {
  const location = useLocation()
  const routerChange = useLink()

  const isInCreateSteps = location.state?.['createSteps']

  // location.stateにcreateStepsがあるかどうかを判断し、
  // 予約作成の各step画面は、他のstepsから遷移されるではなく、直接にアクセスする場合はtoppageにredirectする
  useLayoutEffect(() => {
    if (!isInCreateSteps) {
      navigate(`${routerChange}/`)
    }
  }, [isInCreateSteps, routerChange])

  return {
    isInCreateSteps,
  }
}

export default useCreateStepsJudgement
